import React from 'react'
import Img from 'gatsby-image'

import '../styles/gallery.scss'

const Gallery = (props) => {
    return (
        <div className="gallery-grid">
            {props.data.map((post) => {
                return (
                    <Img classname="gallery-img" fluid={post.node.childImageSharp.fluid} />
                )
            })}
        </div>
    )
}

export default Gallery
